import { IResourceComponentsProps } from '@refinedev/core';
import { AntdInferencer } from '@refinedev/inferencer/antd';

export const UsersShow: React.FC<IResourceComponentsProps> = () => {
  return <AntdInferencer />;
};
